import { config } from '@/config';
import { createClient } from 'graphql-ws';
import type { RequestParameters, Variables } from 'relay-runtime';
import { Observable } from 'relay-runtime';

// Function to get all cookies as an object
const getCookies = (): Record<string, string> => {
  const cookies: Record<string, string> = {};
  document.cookie.split(';').forEach(cookie => {
    const [name, value] = cookie.trim().split('=');
    if (name && value) {
      cookies[name] = decodeURIComponent(value);
    }
  });
  return cookies;
};

const subscriptionsClient = createClient({
  url: config.GRAPHQL_SUBSCRIPTION_URL || 'ws://localhost:5666/graphql',
  lazyCloseTimeout: 1 * 60 * 1000, // 1 minute to close ws connection
  connectionParams: () => ({
    cookies: getCookies(),
  }),
  // debug
  on: {
    connecting: () => {
      // eslint-disable-next-line
      console.log('[graphql-ws] connecting');
    },
    connected: () => {
      // eslint-disable-next-line
      console.log('[graphql-ws] connected');
    },
    closed: (closeEvent: any) => {
      // eslint-disable-next-line
      console.log('[graphql-ws] closed', {
        closeEvent,
        code: closeEvent.code,
        reason: closeEvent.reason,
      });
    },
    opened: () => {
      // eslint-disable-next-line
      console.log('[graphql-ws] opened ');
    },
    ping: () => {
      // eslint-disable-next-line
      console.log('[graphql-ws] ping ');
    },
    pong: () => {
      // eslint-disable-next-line
      console.log('[graphql-ws] pong ');
    },
    message: () => {
      // eslint-disable-next-line
      console.log('[graphql-ws] message ');
    },
    error: (error) => {
      // eslint-disable-next-line
      console.log('[graphql-ws] error ', error);
    },
  },
});

export const subscribeFn = (
  operation: RequestParameters,
  variables: Variables,
) => {
  console.log('subscribeFn called with operation:', operation.name, 'variables:', variables)

  return Observable.create((sink) => {
    if (!operation.text) {
      return sink.error(new Error('Operation text cannot be empty'));
    }

    console.log('Creating GraphQL subscription with operation:', operation.name)

    return subscriptionsClient.subscribe(
      {
        operationName: operation.name,
        query: operation.text,
        variables,
      },
      {
        ...sink,
        error: (err) => {
          if (Array.isArray(err)) {
            // GraphQLError[]
            return sink.error(
              new Error(err.map(({ message }) => message).join(', ')),
            );
          }

          if (err instanceof CloseEvent) {
            return sink.error(
              new Error(
                `Socket closed with event ${err.code} ${err.reason || ''}`, // reason will be available on clean closes only
              ),
            );
          }

          return sink.error(err);
        },
      },
    );
  });
};
